import { Component, OnInit } from '@angular/core';
import { AdalService } from '../shared/azure-authentication/adal.service';
import { CalendarService } from '../calendar/calendar.service';

@Component({
  selector: 'app-teams',
  templateUrl: './teams.component.html',
  styleUrls: ['./teams.component.css']
})
export class TeamsComponent implements OnInit {
  constructor(private adalService: AdalService, private calendarService: CalendarService) {
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/teams/teams.component.ts